<template>

	<div id="properties">

		<br-hero
			:title="'properties_page_landing' | staticTitle"
			:subtitle="'properties_page_landing' | staticContentAlt"
			:heroImg="'properties_page_landing' | staticImg"
			:buttonLabel="'Know more' | i"
			href="#managment-services">

			<vue-marked>
				{{ 'properties_page_landing' | staticContent }}
			</vue-marked>

		</br-hero>

		<section class="properties-potential">

			<div class="limit-width">

				<div class="properties-potential__header">

					<h2>
						{{ 'properties_page_potential' | staticTitle }}
					</h2>

					<h3>
						{{ 'properties_page_potential' | staticContentAlt }}
					</h3>

				</div>

				<div class="properties-potential__content">

					<vue-marked>
						{{ 'properties_page_potential' | staticContent }}
					</vue-marked>

				</div>

			</div>

		</section>

		<section class="properties-elements" id="elements-collection">

			<div class="limit-width">

				<div class="properties-elements__header">

					<h2>
						{{ 'properties_page_elements' | staticTitle }}
					</h2>

					<h3>
						{{ 'properties_page_elements' | staticContentAlt }}
					</h3>

				</div>

				<div class="properties-elements__content">

					<vue-marked>
						{{ 'properties_page_elements' | staticContent }}
					</vue-marked>

				</div>

			</div>

		</section>

		<section class="properties-principles">

			<div class="limit-width">

				<div class="properties-principles__grid">

					<article
						class="properties-principles__item"
						v-for="item in [
							'properties_page_element_place',
							'properties_page_element_ownership',
							'properties_page_element_experience',
							'properties_page_element_hospitality',
							'properties_page_element_stewardship'
						]"
						:key="item"
					>

						<h2>
							{{ item | staticTitle }}
						</h2>

						<h3>
							{{ item | staticContentAlt }}
						</h3>

						<vue-marked>
							{{ item | staticContent }}
						</vue-marked>

					</article>

				</div>

			</div>

		</section>

		<section class="properties-pneumaroca" id="pneumaroca">

			<div class="limit-width">

				<div class="properties-pneumaroca__header">

					<h2>
						{{ 'properties_page_pneumaroca' | staticTitle }}
					</h2>

					<h3>
						{{ 'properties_page_pneumaroca' | staticContentAlt }}
					</h3>

				</div>

				<div class="properties-pneumaroca__content">

					<vue-marked>
						{{ 'properties_page_pneumaroca' | staticContent }}
					</vue-marked>

				</div>

				<a
					class="properties-pneumaroca__button"
					href="#managment-services"
				>
					Discover PneumaRoca
				</a>

			</div>

		</section>

		<section class="properties-gastronomy">

			<div class="limit-width">

				<div class="properties-gastronomy__header">

					<h2>
						{{ 'properties_page_gastronomy' | staticTitle }}
					</h2>

				</div>

				<div class="properties-gastronomy__content">

					<vue-marked>
						{{ 'properties_page_gastronomy' | staticContent }}
					</vue-marked>

				</div>

				<a
					class="properties-gastronomy__link"
					href="#pneumaroca"
				>
					Explore PneumaRoca →
				</a>

			</div>

		</section>

		<section class="properties-active-living">

			<div class="limit-width">

				<div class="properties-active-living__header">

					<h2>
						{{ 'properties_page_active_living' | staticTitle }}
					</h2>

				</div>

				<div class="properties-active-living__content">

					<vue-marked>
						{{ 'properties_page_active_living' | staticContent }}
					</vue-marked>

				</div>

			</div>

		</section>

		<section class="properties-ownership-experience">

			<div class="limit-width">

				<div class="properties-ownership-experience__header">

					<h2>
						{{ 'properties_page_ownership_experience' | staticTitle }}
					</h2>

				</div>

				<div class="properties-ownership-experience__content">

					<vue-marked>
						{{ 'properties_page_ownership_experience' | staticContent }}
					</vue-marked>

				</div>

			</div>

		</section>

		<section class="properties-scale">

			<div class="limit-width">

				<div class="properties-scale__header">

					<h2>
						{{ 'properties_page_scale' | staticTitle }}
					</h2>

				</div>

				<div class="properties-scale__content">

					<vue-marked>
						{{ 'properties_page_scale' | staticContent }}
					</vue-marked>

				</div>

			</div>

		</section>

		<section class="properties-travel">

			<div class="limit-width">

				<div class="properties-travel__header">

					<h2>
						{{ 'properties_page_travel' | staticTitle }}
					</h2>

				</div>

				<div class="properties-travel__content">

					<vue-marked>
						{{ 'properties_page_travel' | staticContent }}
					</vue-marked>

				</div>

			</div>

		</section>

		<section class="properties-partners">

			<div class="limit-width">

				<div class="properties-partners__header">

					<h2>
						{{ 'properties_page_partners' | staticTitle }}
					</h2>

				</div>

				<div class="properties-partners__content">

					<vue-marked>
						{{ 'properties_page_partners' | staticContent }}
					</vue-marked>

				</div>

			</div>

		</section>

		<section class="properties-due-diligence">

			<div class="limit-width">

				<div class="properties-due-diligence__header">

					<h2>
						{{ 'properties_page_due_diligence' | staticTitle }}
					</h2>

				</div>

				<div class="properties-due-diligence__content">

					<vue-marked>
						{{ 'properties_page_due_diligence' | staticContent }}
					</vue-marked>

				</div>

			</div>

		</section>

		<section class="properties-final-cta">

		<div class="limit-width">

			<div class="properties-final-cta__content">

				<h2>
					{{ 'properties_page_final_cta' | staticTitle }}
				</h2>

				<vue-marked>
					{{ 'properties_page_final_cta' | staticContent }}
				</vue-marked>

			</div>

			<div class="properties-final-cta__actions">

				<a
					class="properties-final-cta__button"
					href="#"
				>
					Present a Property Opportunity
				</a>

				<a
					class="properties-final-cta__link"
					href="/ventures"
				>
					Explore Reyrock Ventures
				</a>

			</div>

		</div>

	</section>

		<section class="about" v-if="parseInt($route.meta.descriptionCols) > 0">

			<div class="container">

				<div class="about__top">

					<h2 class="about__heading">
						{{ 'About ' + $route.meta.title | i }}
					</h2>

				</div>

				<div class="about__grid">

					<article class="about__card" v-for="i in parseInt($route.meta.descriptionCols)" :key="'i-' + i">

						<!-- <div class="about__icon">
							<i class="fa-solid fa-link"></i>
						</div> -->

						<h3 class="about__title">
							{{ $route.meta.key + '_col_' + i | staticTitle }}
						</h3>

						<div class="about__text">
							<vue-marked>{{ $route.meta.key + '_col_' + i | staticContent }}</vue-marked>
						</div>

					</article>

				</div>

			</div>

		</section>

		<section id="managment-services" class="projects">

			<div class="container">
				<div class="vue-markd-container">
					<vue-marked>{{ $route.meta.key + '_col_belt' | staticContent }}</vue-marked>
				</div>

				<projects-item v-for="(project, index) in $options.filters.portfolioFetchBy($route.meta.key)"
					:key="index" :project="project" />

			</div>

		</section>


	</div>

</template>

<script>
/* eslint-disable */

import BrHero from '../components/br-hero.vue';
import projectsItem from '../components/projects-item.vue';
export default {
	name: 'Portfolio',

	props: {
		debug: {
			type: Boolean,
			default: false
		}
	},

	components: {
		BrHero,
		projectsItem
	},

	methods: {
		loadUp() {
			document.title = 'Bridgerocks | ' + this.$options.filters.i(this.$route.meta.title);
			if (window.mainUI && typeof window.mainUI === 'function')
				setTimeout(window.mainUI, 150);
		}
	},

	mounted() {
		this.loadUp()
	},

	watch: {
		'$route.meta.key': function () {
			this.loadUp();
		}
	}

};
</script>

<style lang="scss">
#properties {

	.vue-markd-container {
		margin-bottom: 3rem !important;

		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			margin-bottom: 30px;
			font-family: "Cormorant Garamond", serif;
			font-size: 48px;
			font-weight: 500;
			color: #1E2A3A;
			line-height: 1;
		}
	}

	.about {
		p {
			margin: initial;
		}

		&__top {
			margin-bottom: inherit;
		}

		&__grid {
			display: flex;
			flex-flow: row;

			@media screen and (max-width: 800px) {
				flex-flow: column;
			}

			&__card {
				flex: 1 1 auto;
			}
		}

		&__text {
			ul {
				/* list-style: none; */
				list-style: inside;
			}
		}
	}



    .hero + .partners {
        margin-top: 8em;
    }

	.limit-width {
		width: calc(100% - 30px);
		max-width: 1280px;
		margin: auto;
	}

	.properties-potential,
	.properties-elements,
	.properties-principles,
	.properties-pneumaroca,
	.properties-gastronomy,
	.properties-active-living,
	.properties-ownership-experience,
	.properties-scale,
	.properties-travel,
	.properties-partners,
	.properties-due-diligence,
	.properties-final-cta {
		padding: 52px 0;
	}

	.properties-potential__header,
	.properties-elements__header,
	.properties-pneumaroca__header,
	.properties-gastronomy__header,
	.properties-active-living__header,
	.properties-ownership-experience__header,
	.properties-scale__header,
	.properties-travel__header,
	.properties-partners__header,
	.properties-due-diligence__header {
		margin-bottom: 24px;
	}

	.properties-potential h2,
	.properties-elements h2,
	.properties-pneumaroca h2,
	.properties-gastronomy h2,
	.properties-active-living h2,
	.properties-ownership-experience h2,
	.properties-scale h2,
	.properties-travel h2,
	.properties-partners h2,
	.properties-due-diligence h2,
	.properties-final-cta h2 {
		font-family: "Cormorant Garamond", serif;
		font-size: 2.35rem;
		font-weight: 400;
		line-height: 1.05;
		color: #1F2B3D;
	}

	.properties-potential h3,
	.properties-elements h3,
	.properties-pneumaroca h3 {
		margin-top: 10px;

		font-family: "Inter", sans-serif;
		font-size: .78rem;
		font-weight: 600;

		letter-spacing: .12em;
		text-transform: uppercase;

		color: #B45D2D;
	}

	.properties-potential__content,
	.properties-elements__content,
	.properties-pneumaroca__content,
	.properties-gastronomy__content,
	.properties-active-living__content,
	.properties-ownership-experience__content,
	.properties-scale__content,
	.properties-travel__content,
	.properties-partners__content,
	.properties-due-diligence__content {
		color: #394455;

		font-size: .95rem;
		line-height: 1.8;
	}

	.properties-potential__content p,
	.properties-elements__content p,
	.properties-pneumaroca__content p,
	.properties-gastronomy__content p,
	.properties-active-living__content p,
	.properties-ownership-experience__content p,
	.properties-scale__content p,
	.properties-travel__content p,
	.properties-partners__content p,
	.properties-due-diligence__content p {
		margin-bottom: 15px;
	}

	.properties-potential__content p:last-child,
	.properties-elements__content p:last-child,
	.properties-pneumaroca__content p:last-child,
	.properties-gastronomy__content p:last-child,
	.properties-active-living__content p:last-child,
	.properties-ownership-experience__content p:last-child,
	.properties-scale__content p:last-child,
	.properties-travel__content p:last-child,
	.properties-partners__content p:last-child,
	.properties-due-diligence__content p:last-child {
		margin-bottom: 0;
	}

	.properties-elements {
		background: #ECE8E0;
	}

	.properties-principles {
		background: #1F2B3D;
	}

	.properties-principles__grid {
		display: grid;
		grid-template-columns: 1fr;
	}

	.properties-principles__item {
		min-width: 0;	
		padding: 30px 0;
		border: 0;
	}

	.properties-principles__item:first-child {
		padding-top: 0;
	}

	.properties-principles__item:last-child {
		padding: 30px 0;
	}

	.properties-principles__item h2 {
		margin-bottom: 8px;

		font-family: "Cormorant Garamond", serif;
		font-size: 2rem;
		font-weight: 400;
		line-height: 1;

		color: #fff;
	}

	.properties-principles__item h3 {
		margin-bottom: 15px;

		font-size: .75rem;
		font-weight: 600;
		letter-spacing: .12em;
		text-transform: uppercase;

		color: #D97943;
	}

	.properties-principles__item p {
		font-size: .9rem;
		line-height: 1.75;

		color: rgba(255,255,255,.72);
	}

	.properties-pneumaroca {
		background: #F5F1EB;
	}

	.properties-pneumaroca__button {
		display: inline-flex;
		align-items: center;
		justify-content: center;

		margin-top: 24px;
		padding: 14px 24px;

		background: #B45D2D;
		color: #fff;

		font-size: .9rem;

		transition: .3s;
	}

	.properties-pneumaroca__button:hover {
		background: #8C4725;
	}

	.properties-gastronomy {
		background: #201B1C;
	}

	.properties-gastronomy h2 {
		color: #fff;
	}

	.properties-gastronomy__content {
		color: rgba(255,255,255,.72);
	}

	.properties-gastronomy__link {
		display: inline-flex;

		margin-top: 22px;

		font-size: .9rem;
		font-weight: 500;

		color: #D97943;
	}

	.properties-active-living,
	.properties-scale,
	.properties-partners {
		background: #ECE8E0;
	}

	.properties-ownership-experience,
	.properties-travel,
	.properties-due-diligence {
		background: #F5F1EB;
	}

	.properties-final-cta {
		background: #1F2B3D;
		color: #fff;
	}

	.properties-final-cta h2 {
		color: #fff;
	}

	.properties-final-cta__content p {
		margin-top: 18px;

		font-size: .95rem;
		line-height: 1.8;

		color: rgba(255,255,255,.72);
	}

	.properties-final-cta__actions {
		display: flex;
		flex-direction: column;
		align-items: flex-start;

		gap: 15px;

		margin-top: 28px;
	}

	.properties-final-cta__button {
		display: inline-flex;

		padding: 14px 22px;

		background: #B45D2D;
		color: #fff;

		font-size: .9rem;
	}

	.properties-final-cta__link {
		font-size: .9rem;
		color: #D97943;
	}

	@media (min-width: 768px) {

		.properties-potential,
		.properties-elements,
		.properties-principles,
		.properties-pneumaroca,
		.properties-gastronomy,
		.properties-active-living,
		.properties-ownership-experience,
		.properties-scale,
		.properties-travel,
		.properties-partners,
		.properties-due-diligence,
		.properties-final-cta {
			padding: 65px 0;
		}

		.properties-potential h2,
		.properties-elements h2,
		.properties-pneumaroca h2,
		.properties-gastronomy h2,
		.properties-active-living h2,
		.properties-ownership-experience h2,
		.properties-scale h2,
		.properties-travel h2,
		.properties-partners h2,
		.properties-due-diligence h2,
		.properties-final-cta h2 {
			font-size: 3rem;
		}

		.properties-principles__grid {
			grid-template-columns: repeat(2, 1fr);
			gap: 0 45px;
		}

		.properties-principles__item {
			padding: 30px 0;
		}

		.properties-principles__item:first-child {
			padding-top: 30px;
		}

		.properties-principles__item:last-child {
			padding-bottom: 30px;
		}

		.properties-final-cta__actions {
			flex-direction: row;
			align-items: center;
			gap: 25px;
		}

	}

	@media (min-width: 1100px) {

		.properties-potential,
		.properties-elements,
		.properties-pneumaroca,
		.properties-gastronomy,
		.properties-active-living,
		.properties-ownership-experience,
		.properties-scale,
		.properties-travel,
		.properties-partners,
		.properties-due-diligence {
			padding: 78px 0;
		}

		.properties-principles {
			padding: 70px 0;
		}

		.properties-potential .limit-width,
		.properties-elements .limit-width,
		.properties-pneumaroca .limit-width,
		.properties-gastronomy .limit-width,
		.properties-active-living .limit-width,
		.properties-ownership-experience .limit-width,
		.properties-scale .limit-width,
		.properties-travel .limit-width,
		.properties-partners .limit-width,
		.properties-due-diligence .limit-width {
			display: grid;
			grid-template-columns: .85fr 1.15fr;

			gap: 75px;
			align-items: start;
		}

		.properties-potential__header,
		.properties-elements__header,
		.properties-pneumaroca__header,
		.properties-gastronomy__header,
		.properties-active-living__header,
		.properties-ownership-experience__header,
		.properties-scale__header,
		.properties-travel__header,
		.properties-partners__header,
		.properties-due-diligence__header {
			margin-bottom: 0;
		}

		.properties-potential h2,
		.properties-elements h2,
		.properties-pneumaroca h2,
		.properties-gastronomy h2,
		.properties-active-living h2,
		.properties-ownership-experience h2,
		.properties-scale h2,
		.properties-travel h2,
		.properties-partners h2,
		.properties-due-diligence h2 {
			font-size: 3.6rem;
		}

		.properties-potential__content,
		.properties-elements__content,
		.properties-pneumaroca__content,
		.properties-gastronomy__content,
		.properties-active-living__content,
		.properties-ownership-experience__content,
		.properties-scale__content,
		.properties-travel__content,
		.properties-partners__content,
		.properties-due-diligence__content {
			max-width: 680px;

			font-size: 1rem;
			line-height: 1.85;
		}

		.properties-principles__grid {
			grid-template-columns: repeat(3, minmax(0, 1fr));
			gap: 0 35px;
		}

		.properties-principles__item {
			min-width: 0;

			padding: 30px 0;

			border: 0;
		}

		.properties-principles__item:first-child {
			padding: 30px 0;
		}

		.properties-principles__item:last-child {
			padding: 30px 0;
		}

		.properties-principles__item h2 {
			font-size: 2.15rem;

			overflow-wrap: anywhere;
		}

		.properties-pneumaroca .limit-width {
			grid-template-columns: .85fr 1.15fr;
		}

		.properties-pneumaroca__button {
			grid-column: 2;

			width: max-content;
			margin-top: 5px;
		}

		.properties-gastronomy__link {
			grid-column: 2;

			width: max-content;
			margin-top: 8px;
		}

		.properties-final-cta {
			padding: 72px 0;
		}

		.properties-final-cta .limit-width {
			display: grid;
			grid-template-columns: 1.2fr .8fr;

			gap: 70px;
			align-items: center;
		}

		.properties-final-cta h2 {
			font-size: 3.6rem;
		}

		.properties-final-cta__actions {
			margin-top: 0;

			display: flex;
			flex-direction: row;
			align-items: center;

			gap: 30px;
		}

		.properties-final-cta__button,
		.properties-final-cta__link {
			display: inline-flex;
			align-items: center;
			min-height: 54px;
		}

		.properties-final-cta__button {
			padding: 0 28px;
		}

		.properties-final-cta__link {
			white-space: nowrap;
		}

	}


}
</style>

